export const SIGN_IN = "SIGN_IN";
export const ACTIVATE_ACCOUNT = "ACTIVATE_ACCOUNT";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const SEND_RESET_PASSWORD_EMAIL_CONFIRMATION =
    "SEND_RESET_PASSWORD_EMAIL_CONFIRMATION";
